(function($) {
$(function(){

    var $widgets = $('.latest-events');
    if (!$widgets.length) return;

    var template_url = $('#template_url').val();

    $widgets.each(function(){
        var $w        = $(this);
        var $list     = $w.find('.latest-events__list');
        var $loadWrap = $w.find('.latest-events__load-more');
        var $loadBtn  = $w.find('.js-latest-events-load-more');
        var $toggles  = $w.find('.js-latest-events-toggle');
        var $title    = $w.find('.js-latest-events-title');

        var configs = {};
        try {
            configs.current = JSON.parse($w.attr('data-current-config'));
            configs.past    = JSON.parse($w.attr('data-past-config'));
        } catch (e) {
            return;
        }

        var mode    = 'current';
        var loading = false;

        function rendered() { return $list.find('.event-item').length; }

        // Show the button only while there are more posts to fetch for this mode.
        function updateButton() {
            if (rendered() < configs[mode].total_posts) {
                $loadWrap.show();
            } else {
                $loadWrap.hide();
            }
        }

        // replace = true  -> mode switch: offset 0, overwrite the list
        // replace = false -> load more:  offset = rendered(), append
        function load(replace) {
            if (loading) return;
            loading = true;

            var cfg  = configs[mode];
            var data = $.extend({}, cfg, { post_count: replace ? 0 : rendered() });

            $loadBtn.addClass('loading').find('span').html(cfg.loading_text);

            $.ajax({
                method: 'GET',
                url: template_url + '/load-more.php',
                data: data
            }).done(function(msg) {
                if (replace) {
                    $list.html(msg);
                } else {
                    $list.append(msg);
                }
                $loadBtn.removeClass('loading').find('span').html(cfg.initial_text);
                loading = false;
                updateButton();
                if (window.AOS && typeof window.AOS.refreshHard === 'function') {
                    window.AOS.refreshHard();
                }
            }).fail(function() {
                $loadBtn.removeClass('loading').find('span').html(cfg.initial_text);
                loading = false;
            });
        }

        $toggles.on('click', function() {
            var newMode = $(this).attr('data-mode');
            if (newMode === mode || loading) return;
            mode = newMode;
            $toggles.removeClass('is-active');
            $(this).addClass('is-active');
            if ($title.length) {
                $title.text($title.attr(newMode === 'past' ? 'data-past-title' : 'data-current-title'));
            }
            // Scroll back to the top of this widget so the newly-loaded list
            // starts in view (matches the theme's accordion scroll pattern).
            $('html, body').stop(true, false).animate({ scrollTop: $w.offset().top }, 300);
            load(true);
        });

        $loadBtn.on('click', function(e) {
            e.preventDefault();
            load(false);
        });

        updateButton();
    });

});
})(jQuery);
